import { Box, List, ListItem, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getBeautifiedLocalDate } from '@/core';
import { AuditorRegistrationDetail } from '../types';

type AuditorRegistrationFormProps = {
  auditorRegistrationDetail?: AuditorRegistrationDetail;
};

const Details = ({ auditorRegistrationDetail }: AuditorRegistrationFormProps) => {
  const { t } = useTranslation();
  const getClassificationName = (classification: AuditorRegistrationDetail['class']): string => {
    if (classification?.name && classification?.code) {
      return `${classification?.code} ${classification.name}`;
    }
    if (classification?.name) {
      return classification?.name;
    }
    return '/';
  };
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <List sx={{ display: 'flex', flexDirection: 'column' }}>
        <ListItem>
          <ListItemText
            primaryTypographyProps={{ fontSize: '1.25rem' }}
            secondaryTypographyProps={{ fontSize: '1rem' }}
            primary={t('Note', { defaultValue: 'Note' })}
            secondary={auditorRegistrationDetail?.note || '/'}
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primaryTypographyProps={{ fontSize: '1.25rem' }}
            secondaryTypographyProps={{ fontSize: '1rem' }}
            primary={t('Classification', { defaultValue: 'Classification' })}
            secondary={getClassificationName(auditorRegistrationDetail?.class)}
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primaryTypographyProps={{ fontSize: '1.25rem' }}
            secondaryTypographyProps={{ fontSize: '1rem' }}
            primary={t('Standard', { defaultValue: 'Standard' })}
            secondary={auditorRegistrationDetail?.standard?.reference || '/'}
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primaryTypographyProps={{ fontSize: '1.25rem' }}
            secondaryTypographyProps={{ fontSize: '1rem' }}
            primary={t('Valid from', { defaultValue: 'Valid from' })}
            secondary={
              <>
                {t('Note', { defaultValue: 'Note' })}:{' '}
                {auditorRegistrationDetail?.validDec?.name || 'N/A'},{' '}
                {t('Date', { defaultValue: 'Date' })}:{' '}
                {auditorRegistrationDetail?.validDat
                  ? getBeautifiedLocalDate(auditorRegistrationDetail?.validDat)
                  : 'N/A'}
              </>
            }
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primaryTypographyProps={{ fontSize: '1.25rem' }}
            secondaryTypographyProps={{ fontSize: '1rem' }}
            primary={t('Confirmed', { defaultValue: 'Confirmed' })}
            secondary={
              <>
                {t('Status changed by', { defaultValue: 'Status changed by' })}:{' '}
                {auditorRegistrationDetail?.confirmed?.name || 'N/A'},{' '}
                {t('Date of change of status', { defaultValue: 'Date of change of status' })}:{' '}
                {auditorRegistrationDetail?.confirmDat
                  ? getBeautifiedLocalDate(auditorRegistrationDetail?.confirmDat)
                  : 'N/A'}
              </>
            }
          />
        </ListItem>
      </List>
    </Box>
  );
};

export default Details;
